import { useGetAllPermissionsQuery } from "../../../../hooks/queries/usePermissionQueries";
import { useCallback } from "react";
export const useRolePermissions = () => {
  const {
    data: permissions = [],
    isLoading: loadingPermissions,
    isError: isPermissionsError,
    refetch,
  } = useGetAllPermissionsQuery();

  const refetchPermissions = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    permissions,
    loadingPermissions,
    isPermissionsError,
    refetchPermissions,
  };
};

export default useRolePermissions;
